import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import LoginModal from '@components/comp-login-modal.js';
import SignupModal from '@components/form/comp-form-signup.js';
import { ApiCall } from '@assets/js/api/commonApi.js';
import { ApiUserInfo } from '@assets/js/util/commonUtil.js';
import '@assets/css/navbar.css';

export default function Navi() {
    const [selectedNo, setSelectedNo] = useState('1');
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [showSignupModal, setShowSignupModal] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isVisible, setIsVisible] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const navGnb = [
        { no: '1', label: 'Home', to: '/', icon: 'bi-house-door' },
        { no: '2', label: '대회', to: '/ve/competition', icon: 'bi-trophy' },
        { no: '4', label: '토너먼트', to: '/ve/trmnt-maker', icon: 'bi-diagram-3' },
        { no: '6', label: 'SYSTEM', to: '/sys/main', icon: 'bi-gear', requireAuth: true },
    ];

    useEffect(() => {
        ApiUserInfo().then(userRes => {
            if (!userRes.success) {
                sessionStorage.removeItem('userInfo');
                setIsLoggedIn(false); // 로그인 상태 변경
            }
        });
    }, []);

    // 컴포넌트 마운트시 로그인 상태 확인 및 스크롤 이벤트 등록
    useEffect(() => {
        checkLoginStatus();

        // 스크롤 이벤트 핸들러
        const handleScroll = () => {
            const currentScrollY = window.scrollY;

            if (currentScrollY < 10) {
                // 최상단 근처면 항상 표시
                setIsVisible(true);
            } else if (currentScrollY > lastScrollY) {
                // 아래로 스크롤
                setIsVisible(false);
                setIsMobileMenuOpen(false); // 모바일 메뉴 닫기
            } else {
                // 위로 스크롤
                setIsVisible(true);
            }

            setLastScrollY(currentScrollY);
        };

        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [lastScrollY]);

    // 로그인 상태 확인
    const checkLoginStatus = () => {
        const userInfo = sessionStorage.getItem('userInfo');
        setIsLoggedIn(!!userInfo);
    };

    // 로그인 버튼 클릭
    const handleLoginClick = () => {
        setShowLoginModal(true);
    };

    // 회원가입 버튼 클릭
    const handleSignupClick = () => {
        setShowSignupModal(true);
    };

    // 로그인 성공 핸들러
    const handleLoginSuccess = () => {
        alert("정상적으로 로그인 되었습니다.");
        setIsLoggedIn(true);
    };

    // 로그아웃 처리
    const handleLogout = async () => {
        if (!window.confirm("로그아웃 하시겠습니까?")) { return; }

        await ApiCall('/auth/signout', {}).then(response => {
            if (response && response.success) {
                // 세션스토리지 데이터 삭제
                sessionStorage.removeItem('userInfo');

                // 로그인 상태 변경
                setIsLoggedIn(false);

                alert('로그아웃 되었습니다.');
            } else {
                console.error('로그아웃 실패:', response.message);
            }
        });
    };

    // 모바일 메뉴 토글
    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    // 메뉴 아이템 클릭 핸들러
    const handleMenuClick = (no) => {
        ApiUserInfo().then(userRes => {
            if (!userRes.success) {
                sessionStorage.removeItem('userInfo');
                setIsLoggedIn(false); // 로그인 상태 변경
            }
        });
        setSelectedNo(no);
        setIsMobileMenuOpen(false);

        // SYSTEM 메뉴 클릭 시 sessionStorage 초기화
        if (no === '6') {
            sessionStorage.removeItem('page::path');
            sessionStorage.removeItem('page::title');
            sessionStorage.removeItem('page::breadcumb');
        }
    };

    // 로그인 상태에 따라 필터링된 메뉴 항목
    const filteredNavGnb = navGnb.filter(item => {
        if (item.requireAuth) {
            return isLoggedIn;
        }
        return true;
    });

    return (
        <>
            <header
                className={`navbar-custom ${isVisible ? 'navbar-visible' : 'navbar-hidden'}`}
            >
                <div className="container">
                    <div className="navbar-content">
                        {/* 로고 영역 (모바일에서도 표시) */}
                        <div className="navbar-brand">
                            <Link to="/" className="text-white text-decoration-none fw-bold">
                                <i className="bi bi-trophy-fill me-2"></i>
                                Sort Tournament Maker
                            </Link>
                        </div>

                        {/* 데스크톱 메뉴 */}
                        <nav className="navbar-menu-desktop">
                            {filteredNavGnb.map((item) => (
                                <Link
                                    key={item.no}
                                    to={item.to}
                                    className={`navbar-menu-item ${selectedNo === item.no ? 'active' : ''}`}
                                    onClick={() => handleMenuClick(item.no)}
                                >
                                    <i className={`bi ${item.icon}`}></i>
                                    {item.label}
                                </Link>
                            ))}
                        </nav>

                        {/* 로그인/로그아웃 버튼 */}
                        <div className="navbar-actions">
                            {isLoggedIn ? (
                                <button
                                    type="button"
                                    className="btn btn-outline-light btn-sm"
                                    onClick={handleLogout}
                                >
                                    <i className="bi bi-box-arrow-right me-1"></i>
                                    <span className="d-none d-md-inline">Logout</span>
                                </button>
                            ) : (
                                <>
                                    <button
                                        type="button"
                                        className="btn btn-outline-light btn-sm me-2"
                                        onClick={handleLoginClick}
                                    >
                                        <i className="bi bi-box-arrow-in-right me-1"></i>
                                        <span className="d-none d-md-inline">Login</span>
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-outline-success btn-sm"
                                        onClick={handleSignupClick}
                                    >
                                        <i className="bi bi-person-plus me-1"></i>
                                        <span className="d-none d-md-inline">Signup</span>
                                    </button>
                                </>
                            )}

                            {/* 모바일 햄버거 메뉴 버튼 */}
                            <button
                                className="navbar-toggler"
                                type="button"
                                onClick={toggleMobileMenu}
                                aria-label="Toggle navigation"
                            >
                                <span className={`navbar-toggler-icon ${isMobileMenuOpen ? 'open' : ''}`}>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </span>
                            </button>
                        </div>
                    </div>

                    {/* 모바일 메뉴 */}
                    <div className={`navbar-menu-mobile ${isMobileMenuOpen ? 'open' : ''}`}>
                        {filteredNavGnb.map((item) => (
                            <Link
                                key={item.no}
                                to={item.to}
                                className={`navbar-menu-mobile-item ${selectedNo === item.no ? 'active' : ''}`}
                                onClick={() => handleMenuClick(item.no)}
                            >
                                <i className={`bi ${item.icon}`}></i>
                                {item.label}
                            </Link>
                        ))}
                    </div>
                </div>
            </header>

            {/* 로그인 모달 */}
            <LoginModal
                show={showLoginModal}
                onHide={() => setShowLoginModal(false)}
                onLoginSuccess={handleLoginSuccess}
            />

            {/* 회원가입 모달 */}
            <SignupModal
                show={showSignupModal}
                onHide={() => setShowSignupModal(false)}
            />
        </>
    );
}
